import { DELETE, GET, POST, PUT, Upload } from "./controller.service";

// Authentication
export const loginApi = (data) => {
  return POST("/org/user_login", data);
};
export const SignUpApi = (data) => {
  return POST("/org/user_registration", data);
};
export const magicLinkApi = (data) => {
  return POST("org/send_link", data);
};
export const forgotPassword = (data) => {
  return POST("org/forgot_password", data);
};
export const resetPasswordApi = (data) => {
  return POST("org/reset_password", data);
};
export const verifyOTPApi = (data) => {
  return POST("org/verify_otp", data);
};
// get user details
export const getUserById = () => {
  return GET("/org/get_user_by_id");
};

export const logoutApi = ()=>{
  return GET("/org/user_logout")
}


// Profile
export const viewProfile = () => {
  return GET("/org/get_profile");
};
export const getProfileComments = (user_id) => {
  return GET(`/org/get_profile_comments?user_id=${user_id}`);
};
export const editProfile = (data) => {
  return POST("/org/edit_profile", data);
};



// Courses
export const allCourses = (data) => {
  return POST("org/get_all_course", data);
};
export const getModuleList = (data) => {
  return POST("/org/get_module_list", data);
};
export const getMyCourses = (data) => {
  return POST("/org/get_my_course", data);
};
// Notes
export const getNotes = (video_id) => {
  return GET(`/org/get_notes_details?video_id=${video_id}`);
};
export const addNote = (data) => {
  return POST("/org/add_note", data);
};
export const getModuleNotes = (moduleId) => {
  return GET(`/org/get_module_notes?module_id=${moduleId}`); // Correct the query parameter name to match your backend
};
export const deleteNotes = (noteId) => {
  return DELETE(`/org/delete_note/${noteId}`);
};

// Comments
export const getComments = (video_id) => {
  return GET(`/org/get_comments_details?video_id=${video_id}`);
};
export const addComment = (data) => {
  return POST("/org/add_comment", data);
};
export const getModuleComments = (moduleId) => {
  return GET(`/org/get_module_comments?module_id=${moduleId}`);
};
export const deleteComment = (comment_id) => {
  return DELETE(`/org/delete_comment/${comment_id}`);
};
export const updateLike = (commentId) => {
  return POST("/org/update_like", { commentId });
};
// Reply Comments
export const addReplyComment = (data) => {
  return POST("/org/add_reply_comment", data);
};
export const getRepliesByCommentId = (data) => {
  return POST("/org/get_replies_by_comment_id", data);
};
export const deleteReplyComment = (replyCommentId) => {
  return DELETE(`/org/delete_reply_comment/${replyCommentId}`);
};

// Rating
export const addCourseReview = (data) => {
  return POST("/org/add_course_review", data);
};
export const getCourseReviews = (course_id, video_id) => {
  const queryParams = video_id ? `course_id=${course_id}&video_id=${video_id}` : `course_id=${course_id}`;
  return GET(`/org/get_course_reviews?${queryParams}`);
};
export const deleteReview = (review_id) => {
  return DELETE(`/org/delete_review/${review_id}`);
};

// help and support
export const getFAQ = () => {
  return GET("/org/get_faqs");
}

export const getAllTicket = (data) => {
  return POST("/org/get_all_raise_ticket", data);
}


// Certificate
export const getCertificateData = () => {
  return GET("/org/certificates");
};
export const postRaiseTicket = (data) => {
  return Upload("/org/raise_ticket", data);
};


// Notification
export const getNotifications = (data) => {
  return POST("/org/get_notifications", data); // Assuming pagination is managed here
};
export const markNotificationAsRead = (notificationId) => {
  return POST("/org/mark_notification_as_read", { notificationId });
};
export const markAllNotificationsAsRead = () => {
  return POST("/org/mark_all_notifications_as_read");
};



// Assessments

export const restartAssessment = (data) => {
  return POST("/org/restart_assessment", data);
};

export const getAssments = (data) => {
  return POST("/org/get_course_assessment", data);
};
export const getAssmentList = (data) => {
  return POST("/org/get_user_assessment", data);
};

export const getTopCourses = () => {
  return GET("/org/top-courses"); // Assuming you're using a POST method here
};

export const getUserLogs = () => {
  return GET("/org/getUserLogs"); // Assuming you're using a POST method here
};

export const getCourseClassroomData = (data) => {
  return POST('/org/course_data', data);
};

export const getModule = (data) => {
  return POST("/org/recorded_video", data);
};

export const getQuestionsByAssessmentId = (assessmentId) => {
  return POST('/org/get_questions', { assessmentId });
};

export const submitAnswers = (data) => {
  return POST('/org/submit_answers', data);
};

export const getQuestions = (data) => {
  return POST("/org/get_questions", data);
};

export const generateToken = (data) => {
  return POST('/org/generate_token', data);
};

// Assignment
export const getAssignments = () => {
  return GET("/org/get_assignments");
};
export const submitAssignment = (data) => {
  return POST("/org/submit_assignment", data); // You can modify the endpoint as per your backend structure.
};


// Performance dashboard
// Rank
export const getRankings = () => {
  return GET('/org/get_rankings');
};

export const getRecentVideos = () => {
  return GET('/org/get_recent_videos');
};

export const saveRecentVideo = (data) => {
  return POST('/org/save_recent_video', data);
};

// Account Settings
export const updateNotificationSettings = (data) => {
  return PUT("/org/update_notification_settings", data);
};
// Update Password from settings
export const updatePasswordAPI = (data) => {
  return PUT("/org/update_passwordAPI", data);
};

// Delete Account
export const deleteUserAccount = (action) => {
  return POST("/org/delete_account", { action });
};

export const addClassroomApproval = (classroom_id) => {
  return POST('/org/add_classroom_approval', { classroom_id });
};
// export const checkClassroomApprovalStatus = (classroom_id) => {
//   return GET(`/org/check_classroom_approval?classroom_id=${classroom_id}`);
// };




// ORGANIZATION


const endpoint = "/mainOrg"

export const orgShowStatus = (classroom_id) => {
  return GET(endpoint + '/stats', { classroom_id });
};

export const getOrgProfile = () => {
  return GET(endpoint + "/profile")
}
export const getUserQueries = () => {
  return GET(endpoint + "/userQueries")
}

export const getPerformance = () => {
  return GET(endpoint + "/org_performance_stats")
}

export const getCourseList = (data) => {
  return GET(endpoint + `/courses?page=${data.page}&limit=${data.limit}`)
}

export const createNewCourse = (data) => {
  return POST(endpoint + `/course/new`, data)
}

export const courseDelete = (data) => {
  return DELETE(endpoint + `/course/${data.id}`)
}
export const getPendingCourses = (data)=>{
  return GET(endpoint+`/pending_courses?page=${data.page}&limit=${data.limit}`)
}

export const approveCourse = (data)=>{
  return POST(endpoint+`/approve_course/${data.id}`);
}

export const rejectCourse = (data)=>{
  return POST(endpoint+`/reject_course/${data.id}`);
}


export const getCourseModule = (data)=>{
  return GET(endpoint+`/modules/${data.id}`);
}


export const getApprovalCourse = (data)=>{
  return POST(endpoint+`/approve_course/${data.id}`);
}

export const RejectApprovalCourse = (data)=>{
  return DELETE(endpoint+`/reject_course/${data.id}`);
}

export const getOrgClasses = (data)=>{
  return GET(endpoint+`/classroom?page=${data.page}&limit=${data.limit}&search=${data.search}`);
}

export const ClassesApprovalRequests = (data)=>{
  return GET(endpoint+`/classroom/students_approval?page=${data.page}&limit=${data.limit}&search=${data.search}`);
}

export const createClassroom = (data)=>{
  return POST(endpoint+`/classroom`);
}

export const getliveClass = ()=>{
  return GET(endpoint+`/classroom/get_live_class`);
}
export const getOrgUsers = (data)=>{
  return GET(endpoint+`/orgUser?page=${data.page}&limit=${data.limit}&status=${data.state}&search=${data.search}`);
}

export const createOrgUsers = (data)=>{
  return GET(endpoint+`/orgUser`,data);
}




// Super Admin

export const loginUserAdmin = (data) => {
  return POST('/superadmin/login',data);
};

// Super Admin Forgot Password
export const forgotPasswordCheckEmailSuperAdmin = (data) => {
  return POST('/superadmin/forgot-password/check-email', data);
};
export const forgotPasswordResetSuperAdmin = (data) => {
  return POST('/superadmin/forgot-password/reset', data);
};

export const viewSuperAdminProfile = () => {
  return GET("/superadmin/getsuperadminprofile");
};
export const getSuperAdminBranding = () => {
  return GET("/superadmin/branding");
};
export const editSuperAdminProfile = (data) => {
  return POST("/superadmin/updatesuperadminprofile", data);
};

// Settings Update Password
export const updateSuperAdminPasswordAPI = (data) => {
  return PUT("/superadmin/updatesuperadminpassword", data);
};

// Super Admin Notifications
export const getSuperAdminNotifications = (data) => {
  return GET("/superadmin/getsuperadminnotifications", data); // Assuming pagination is managed here
};
export const markSuperAdminNotificationAsRead = (notificationId) => {
  return PUT("/superadmin/mark_superadmin_notification_as_read", { notificationId });
};
export const markSuperAdminAllNotificationsAsRead = () => {
  return PUT("/superadmin/mark_superadmin_all_notifications_as_read");
};

// Super Admin Notification Settings
export const getSuperAdminNotificationSettings = (data) => {
  return GET("/superadmin/get_superadmin_notification_settings", data);
};
export const updateSuperAdminNotificationSettings = (data) => {
  return PUT("/superadmin/update_superadmin_notification_settings", data);
};


export const createOrganization = (payload)=>{
  return POST(`/superadmin/create_organization`,payload);
}
// GET Organizations (with optional search, page, limit, status)
export const getOrganizations = (params = {}) => {
  const { search = '', page = 1, limit = 10, status = 'all' } = params;
  return GET('/superadmin/get_organizations', { search, page, limit, status });
};
// PUT Organizations
export const updateOrganization = (payload) => {
  return PUT(`/superadmin/update_organization`, payload);
}
export const activateOrganization = (org_id) => {
  return PUT(`/superadmin/organization/activate/${org_id}`);
};
export const deactivateOrganization = (org_id) => {
  return PUT(`/superadmin/organization/deactivate/${org_id}`);
};
export const deleteOrganization = (org_id) => {
  return PUT(`/superadmin/delete_organization/${org_id}`);
};

// Organizations Growth
export const getOrganizationGrowth = () => {
  return GET('/superadmin/get_organization_growth');
}
// Organizations Total Requests
export const getOrganizationRequests = () => {
  return GET('/superadmin/get_organization_requests');
}
export const updateRequestStatus = (request_id, status) => {
  return PUT(`/superadmin/update-status/${request_id}`, { status });
};

// Super Admin Login
export const superAdminLoginApi = (data) => {
  return POST("/superadmin/login", data);
};
